import {TrackAddShippingInfoDto} from "@app/core/tracking/domain/dtos/track-add-shipping-info.dto";
import {TrackedItemMapper} from "@app/core/tracking/infrastructure/mappers/tracked-item.mapper";

export class TrackBeginCheckoutDtoMapper {
    static serialize(params: TrackAddShippingInfoDto) {
        return {
            currency: params.currency,
            value: params.value,
            items: params.items.map(TrackedItemMapper.serialize),
        }
    }
}
